export const TEAM_DATA = [
	{
		'ID': '4362',
		'slug': 'brian-ascher',
		'full_name': 'Brian Ascher',
		'focus': 'SaaS & Enterprise, Finance and Payments, “Intelligent Software”',
		'office': 'Palo Alto',
		'user_image': '/wp-content/uploads/2014/02/Brian_Ascher_01_R22.jpg',
		'teams': [
			{
				'slug': 'technology',
				'name': 'Technology',
				'section': 'Investment Team',
			},
		],
		'job_title': 'Partner',
		'section': 'Investment Team',
	},
	{
		'ID': '7865',
		'slug': 'harry-barber',
		'full_name': 'Harry Barber',
		'focus': 'Biotechnology',
		'office': 'New York',
		'user_image': '/wp-content/uploads/2019/07/Harry-Barber.jpeg',
		'teams': [
			{
				'slug': 'public-healthcare',
				'name': 'Public Healthcare',
				'section': 'Investment Team',
			},
		],
		'job_title': 'VHCP',
		'section': 'Investment Team',
	},
	{
		'ID': '7228',
		'slug': 'ethan-batraski',
		'full_name': 'Ethan Batraski',
		'focus': 'Developer Infrastructure, Emerging Tech, Space/Defense',
		'office': 'Palo Alto',
		'user_image': '/wp-content/uploads/2018/04/Ethan-Batraski_Listing.jpg',
		'teams': [
			{
				'slug': 'technology',
				'name': 'Technology',
				'section': 'Investment Team',
			},
		],
		'job_title': 'Partner',
		'section': 'Investment Team',
	},
	{
		'ID': '4352',
		'slug': 'nick-beim',
		'full_name': 'Nick Beim',
		'focus': 'Artificial Intelligence, Software, Fintech and Defense',
		'office': 'New York',
		'user_image': '/wp-content/uploads/2014/02/Nick_Beim_12_R2.jpg',
		'teams': [
			{
				'slug': 'technology',
				'name': 'Technology',
				'section': 'Investment Team',
			},
		],
		'job_title': 'Partner',
		'section': 'Investment Team',
	},
	{
		'ID': '6352',
		'slug': 'racquel-bracken',
		'full_name': 'Racquel Bracken',
		'focus': 'Biotechnology, Pharmaceuticals',
		'office': 'Palo Alto',
		'user_image': '/wp-content/uploads/2016/06/rbracken_listing1.jpg',
		'teams': [
			{
				'slug': 'private-healthcare',
				'name': 'Private Healthcare',
				'section': 'Investment Team',
			},
		],
		'job_title': 'Partner',
		'section': 'Investment Team',
	},
	{
		'ID': '6008',
		'slug': 'paul-dossa',
		'full_name': 'Paul Dossa',
		'focus': 'Biotechnology, Pharmaceuticals',
		'office': 'New York',
		'user_image': '/wp-content/uploads/2015/10/pdossa_listing1.jpg',
		'teams': [
			{
				'slug': 'public-healthcare',
				'name': 'Public Healthcare',
				'section': 'Investment Team',
			},
		],
		'job_title': 'VHCP',
		'section': 'Investment Team',
	},
	{
		'ID': '7335',
		'slug': 'gallagher-gally',
		'full_name': 'Gallagher (Gally)',
		'focus': '',
		'office': 'Palo Alto',
		'user_image': '/wp-content/uploads/2018/09/Gally-website.jpg',
		'teams': [
			{
				'slug': 'private-healthcare',
				'name': 'Private Healthcare',
				'section': 'Investment Team',
			},
		],
		'job_title': 'Therapist/Food Disposal',
		'section': 'Investment Team',
	},
	{
		'ID': '7433',
		'slug': 'andrew-gottesdiener',
		'full_name': 'Andrew Gottesdiener',
		'focus': 'Biotechnology, Pharmaceuticals',
		'office': 'New York',
		'user_image': '/wp-content/uploads/2018/10/Andrew-Gottesdiener_Team.jpeg',
		'teams': [
			{
				'slug': 'public-healthcare',
				'name': 'Public Healthcare',
				'section': 'Investment Team',
			},
		],
		'job_title': 'VHCP',
		'section': 'Investment Team',
	},
	{
		'ID': '8028',
		'slug': 'todd-graham',
		'full_name': 'Todd Graham',
		'focus': 'Enterprise, Cybersecurity, Infrastructure',
		'office': 'Palo Alto',
		'user_image': '/wp-content/uploads/2019/11/Todd-Graham-Team-Listing-2-1.jpg',
		'teams': [
			{
				'slug': 'technology',
				'name': 'Technology',
				'section': 'Investment Team',
			},
		],
		'job_title': 'Vice President',
		'section': 'Investment Team',
	},
	{
		'ID': '8613',
		'slug': 'lesley-kelly',
		'full_name': 'Lesley Kelly',
		'focus': '',
		'office': 'New York',
		'user_image':
			'/wp-content/uploads/2020/10/Team-Listing-Lesley-Kelly-Team-Listing.png',
		'teams': [
			{
				'slug': 'public-healthcare',
				'name': 'Public Healthcare',
				'section': 'Investment Team',
			},
		],
		'job_title': 'Head Trader',
		'section': 'Investment Team',
	},
	{
		'ID': '4369',
		'slug': 'bob-kocher',
		'full_name': 'Bob Kocher, MD',
		'focus': 'Healthcare IT',
		'office': 'Palo Alto',
		'user_image': '/wp-content/uploads/2014/02/bkocher_listing1.jpg',
		'teams': [
			{
				'slug': 'private-healthcare',
				'name': 'Private Healthcare',
				'section': 'Investment Team',
			},
		],
		'job_title': 'Partner',
		'section': 'Investment Team',
	},
	{
		'ID': '4356',
		'slug': 'bong-koh',
		'full_name': 'Bong Koh',
		'focus': 'Biotechnology',
		'office': 'New York',
		'user_image': '/wp-content/uploads/2014/02/Bong-Koh-Team-Listing.png',
		'teams': [
			{
				'slug': 'public-healthcare',
				'name': 'Public Healthcare',
				'section': 'Investment Team',
			},
		],
		'job_title': 'VHCP',
		'section': 'Investment Team',
	},
	{
		'ID': '8182',
		'slug': 'mariana-mihalusova',
		'full_name': 'Mariana Mihalusova',
		'focus': 'Biotechnology, Pharmaceuticals',
		'office': 'Palo Alto',
		'user_image': '/wp-content/uploads/2020/04/Mariana-Mihalusova-Team-Listing.jpg',
		'teams': [
			{
				'slug': 'private-healthcare',
				'name': 'Private Healthcare',
				'section': 'Investment Team',
			},
		],
		'job_title': 'Vice President',
		'section': 'Investment Team',
	},
	{
		'ID': '4361',
		'slug': 'bryan-roberts',
		'full_name': 'Bryan Roberts',
		'focus': 'Biotechnology, Diagnostics, Genomics, Healthcare IT, Medical Devices',
		'office': 'Palo Alto',
		'user_image': '/wp-content/uploads/2014/02/broberts_listing1.jpg',
		'teams': [
			{
				'slug': 'private-healthcare',
				'name': 'Private Healthcare',
				'section': 'Investment Team',
			},
		],
		'job_title': 'Partner',
		'section': 'Investment Team',
	},
	{
		'ID': '6404',
		'slug': 'alex-rosen',
		'full_name': 'Alex Rosen',
		'focus': 'Biotechnology, Pharmaceuticals',
		'office': 'New York',
		'user_image': '/wp-content/uploads/2016/07/Arosen_listing2.jpg',
		'teams': [
			{
				'slug': 'public-healthcare',
				'name': 'Public Healthcare',
				'section': 'Investment Team',
			},
		],
		'job_title': 'VHCP',
		'section': 'Investment Team',
	},
	{
		'ID': '5258',
		'slug': 'camille-samuels',
		'full_name': 'Camille Samuels',
		'focus': 'Biotechnology, Consumer Health, Medical Devices',
		'office': 'Palo Alto',
		'user_image': '/wp-content/uploads/2014/06/csamuels_listing2.jpg',
		'teams': [
			{
				'slug': 'private-healthcare',
				'name': 'Private Healthcare',
				'section': 'Investment Team',
			},
		],
		'job_title': 'Partner',
		'section': 'Investment Team',
	},
	{
		'ID': '4353',
		'slug': 'nimish-shah',
		'full_name': 'Nimish Shah',
		'focus': 'Pharmaceuticals, Biotechnology, Generics',
		'office': 'New York',
		'user_image': '/wp-content/uploads/2014/02/nshah_listing1.jpg',
		'teams': [
			{
				'slug': 'public-healthcare',
				'name': 'Public Healthcare',
				'section': 'Investment Team',
			},
		],
		'job_title': 'VHCP',
		'section': 'Investment Team',
	},
	{
		'ID': '4355',
		'slug': 'mike-tyrrell',
		'full_name': 'Mike Tyrrell',
		'focus': 'Enterprise, Internet, Mobile',
		'office': 'Boston',
		'user_image': '/wp-content/uploads/2014/02/mtyrell_listing.jpg',
		'teams': [
			{
				'slug': 'technology',
				'name': 'Technology',
				'section': 'Investment Team',
			},
		],
		'job_title': 'Partner',
		'section': 'Investment Team',
	},
	{
		'ID': '8578',
		'slug': 'mathai-mammen',
		'full_name': 'Mathai Mammen',
		'focus': '',
		'office': 'Palo Alto',
		'user_image': '/wp-content/uploads/2020/10/Mathai-Mammen-Team-Listing-.jpg',
		'teams': [
			{
				'slug': 'portfolio-advisory-committee',
				'name': 'Portfolio Advisory Committee',
				'section': 'Advisors',
			},
		],
		'job_title': 'Advisor',
		'section': 'Advisors',
	},
	{
		'ID': '8583',
		'slug': 'todd-park',
		'full_name': 'Todd Park',
		'focus': '',
		'office': 'Palo Alto',
		'user_image': '/wp-content/uploads/2020/10/Todd-Park-Team-Listing.jpg',
		'teams': [
			{
				'slug': 'portfolio-advisory-committee',
				'name': 'Portfolio Advisory Committee',
				'section': 'Advisors',
			},
		],
		'job_title': 'Advisor',
		'section': 'Advisors',
	},
	{
		'ID': '7110',
		'slug': 'dj-patil',
		'full_name': 'DJ Patil',
		'focus': '',
		'office': 'Palo Alto',
		'user_image': '/wp-content/uploads/2017/11/DJ-team-listing.jpg',
		'teams': [
			{
				'slug': 'portfolio-advisory-committee',
				'name': 'Portfolio Advisory Committee',
				'section': 'Advisors',
			},
		],
		'job_title': 'Advisor',
		'section': 'Advisors',
	},
	{
		'ID': '8573',
		'slug': 'kole-roybal',
		'full_name': 'Kole Roybal',
		'focus': '',
		'office': 'Palo Alto',
		'user_image': '/wp-content/uploads/2020/10/Kole-Roybal-Team-Listing.png',
		'teams': [
			{
				'slug': 'portfolio-advisory-committee',
				'name': 'Portfolio Advisory Committee',
				'section': 'Advisors',
			},
		],
		'job_title': 'Advisor',
		'section': 'Advisors',
	},
	{
		'ID': '8568',
		'slug': 'john-stuelpnagel',
		'full_name': 'John Stuelpnagel',
		'focus': '',
		'office': 'Palo Alto',
		'user_image': '/wp-content/uploads/2020/10/John-StuelpnagelTeam-Listing-.jpg',
		'teams': [
			{
				'slug': 'portfolio-advisory-committee',
				'name': 'Portfolio Advisory Committee',
				'section': 'Advisors',
			},
		],
		'job_title': 'Advisor',
		'section': 'Advisors',
	},
	{
		'ID': '4360',
		'slug': 'tony-evnin',
		'full_name': 'Tony Evnin',
		'focus': 'Biotechnology, Medical Devices',
		'office': 'New York',
		'user_image': '/wp-content/uploads/2014/02/tevning_listing.jpg',
		'teams': [
			{
				'slug': 'venture-development',
				'name': 'Venture Development',
				'section': 'Venture Development',
			},
		],
		'job_title': 'Partner',
		'section': 'Venture Development',
	},
	{
		'ID': '4344',
		'slug': 'steve-goldby',
		'full_name': 'Steve Goldby',
		'focus': '',
		'office': 'None',
		'user_image': '/wp-content/uploads/2014/02/sgoldby_listing1.jpg',
		'teams': [
			{
				'slug': 'venture-development',
				'name': 'Venture Development',
				'section': 'Venture Development',
			},
		],
		'job_title': 'Partner Emeritus',
		'section': 'Venture Development',
	},
	{
		'ID': '4364',
		'slug': 'david-pakman',
		'full_name': 'David Pakman',
		'focus': 'Consumer Products and Services, Robotics and Automation, Crypto',
		'office': 'New York',
		'user_image': '/wp-content/uploads/2014/02/dpackman_listing.jpg',
		'teams': [
			{
				'slug': 'venture-development',
				'name': 'Venture Development',
				'section': 'Venture Development',
			},
		],
		'job_title': 'Partner',
		'section': 'Venture Development',
	},
	{
		'ID': '4363',
		'slug': 'lisa-harris',
		'full_name': 'Lisa Harris',
		'focus': '',
		'office': 'Palo Alto',
		'user_image': '/wp-content/uploads/2014/02/lharris_listing2.jpg',
		'teams': [
			{
				'slug': 'operations',
				'name': 'Operations',
				'section': 'Operations',
			},
		],
		'job_title': 'CFO',
		'section': 'Operations',
	},
	{
		'ID': '4359',
		'slug': 'christy-lawrence',
		'full_name': 'Christy Lawrence',
		'focus': '',
		'office': 'Palo Alto',
		'user_image': '/wp-content/uploads/2014/02/clawrence_listing1.jpg',
		'teams': [
			{
				'slug': 'operations',
				'name': 'Operations',
				'section': 'Operations',
			},
		],
		'job_title': 'Vice President of Finance',
		'section': 'Operations',
	},
	{
		'ID': '6948',
		'slug': 'sharah-marwah',
		'full_name': 'Sharah Marwah',
		'focus': '',
		'office': 'Palo Alto',
		'user_image': '/wp-content/uploads/2017/07/smarwah_listing1.jpg',
		'teams': [
			{
				'slug': 'operations',
				'name': 'Operations',
				'section': 'Operations',
			},
		],
		'job_title': 'Head of Talent',
		'section': 'Operations',
	},
	{
		'ID': '4366',
		'slug': 'nicole-pack',
		'full_name': 'Nicole Pack',
		'focus': '',
		'office': 'Palo Alto',
		'user_image': '/wp-content/uploads/2014/02/npack_listing1.jpg',
		'teams': [
			{
				'slug': 'operations',
				'name': 'Operations',
				'section': 'Operations',
			},
		],
		'job_title': 'CMO',
		'section': 'Operations',
	},
	{
		'ID': '4367',
		'slug': 'sherman-souther',
		'full_name': 'Sherman Souther',
		'focus': '',
		'office': 'Palo Alto',
		'user_image': '/wp-content/uploads/2014/02/ssouther_listing1.jpg',
		'teams': [
			{
				'slug': 'operations',
				'name': 'Operations',
				'section': 'Operations',
			},
		],
		'job_title': 'Associate General Counsel',
		'section': 'Operations',
	},
	{
		'ID': '4346',
		'slug': 'david-stepp',
		'full_name': 'David Stepp',
		'focus': '',
		'office': 'Palo Alto',
		'user_image': '/wp-content/uploads/2014/02/dstepp_listing1.jpg',
		'teams': [
			{
				'slug': 'operations',
				'name': 'Operations',
				'section': 'Operations',
			},
		],
		'job_title': 'Partner',
		'section': 'Operations',
	},
];
